import React, { useState } from 'react'
import Header from '../../header/Header'
import { useHistory, useLocation } from 'react-router-dom'
import { routes } from '../../../constantes/routes'
import './view-seguimiento.scss'

const ViewSeguimientoComercialContainer = () => {
  const history = useHistory()
  const location = useLocation()
  const leadData = location.state && location.state.leadData
  const [activeTab, setActiveTab] = useState('internas')

  // Si no hay datos, redirigir de vuelta
  if (!leadData) {
    history.push(routes.SEGUIMIENTO_COMERCIAL)
    return null
  }

  const toMain = () => {
    history.push(routes.MAIN)
  }

  const toSeguimiento = () => {
    history.push(routes.SEGUIMIENTO_COMERCIAL)
  }

  const renderStars = (priority) => {
    return '★'.repeat(priority)
  }

  return (
    <div className='products'>
      <Header text={'Oportunidad Lead'} route={toSeguimiento} backBtn={true} />

      <div className='view-seguimiento-container'>
        <div className='main-layout'>
          {/* Columna izquierda - Información del lead y tabs */}
          <div className='left-column'>
            {/* Sección de botones de estado */}
            <div className='lead-status-section'>
              <div className='status-buttons'>
                <button className='btn'>Nuevo Lead</button>
                <button className='btn'>Ganada</button>
                <button className='btn'>Perdido</button>
              </div>
            </div>

            {/* Información principal del lead */}
            <div className='lead-info-section'>
              <div className='lead-info-grid'>
                {/* Columna izquierda */}
                <div className='lead-info-column'>
                  <div className='info-group'>
                    <span className='info-label'>Ingreso esperado</span>
                    <span className='info-value'>{leadData.amount}</span>
                  </div>

                  <div className='info-group'>
                    <span className='info-label'>Correo Electronico</span>
                    <span className='info-value info-value--email'>
                      {leadData.email}
                    </span>
                  </div>
                </div>

                {/* Columna central */}
                <div className='lead-info-column'>
                  <div className='info-group'>
                    <span className='info-label'>Cliente</span>
                    <span className='info-value'>{leadData.client}</span>
                  </div>

                  <div className='info-group'>
                    <span className='info-label'>Telefono</span>
                    <span className='info-value'>{leadData.phone}</span>
                  </div>
                </div>

                {/* Columna derecha */}
                <div className='lead-info-column'>
                  <div className='info-group'>
                    <span className='info-label'>Comercial</span>
                    <span className='info-value'>{leadData.commercial}</span>
                  </div>

                  <div className='info-group'>
                    <span className='info-label'>Prioridad</span>
                    <div className='priority-stars'>
                      {renderStars(leadData.priority)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sección de tabs */}
            <div className='tabs-section'>
              <div className='tabs-nav'>
                <button
                  className={`tab-btn ${
                    activeTab === 'internas' ? 'tab-btn--active' : ''
                  }`}
                  onClick={() => setActiveTab('internas')}
                >
                  Notas internas
                </button>
                <button
                  className={`tab-btn ${
                    activeTab === 'adicional' ? 'tab-btn--active' : ''
                  }`}
                  onClick={() => setActiveTab('adicional')}
                >
                  Información adicional
                </button>
              </div>

              {/* Contenido de las tabs */}
              <div className='tab-content'>
                {activeTab === 'internas' && (
                  <div className='notes-content'>
                    <p className='note-text'>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Suspendisse eu elementum est, id fringilla metus. Quisque
                      gravida est quis urna iaculis bibendum. Maecenas gravida
                      velit et ligula malesuada scelerisque. Sed risus massa,
                      suscipit et posuere ut, vestibulum id eros. Morbi leo
                      enim, iaculis dapibus dictum vel, pellentesque a purus.
                      Aliquam vitae diam tellus. Integer nec urna vel justo
                      fringilla dictum.
                    </p>
                    <p className='note-text'>
                      Maecenas gravida velit et ligula malesuada scelerisque.
                      Sed risus massa, suscipit et posuere ut, vestibulum id
                      eros. Morbi leo enim, iaculis dapibus dictum vel,
                      pellentesque a purus. Aliquam vitae diam tellus. Integer
                      nec urna vel justo fringilla dictum. Maecenas gravida
                      velit et ligula malesuada scelerisque.
                    </p>
                  </div>
                )}

                {activeTab === 'adicional' && (
                  <div className='additional-content'>
                    <p className='note-text'>
                      Información adicional del lead. Aquí se puede incluir
                      datos específicos, historial de interacciones,
                      preferencias del cliente y otros detalles relevantes para
                      el seguimiento comercial.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Columna derecha - Comentarios */}
          <div className='right-column'>
            <div className='comments-section'>
              <div className='comments-grid'>
                {/* Comentario 1 */}
                <div className='comment-item'>
                  <div className='comment-header'>
                    <span className='comment-author'>Nombre</span>
                    <span className='comment-type'>Comentarios</span>
                    <span className='comment-date'>Hoy a las 16:55</span>
                  </div>
                  <p className='comment-text'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse eu elementum est, id fringilla metus. Quisque
                    gravida est quis urna iaculis bibendum. Maecenas gravida
                    velit et ligula malesuada scelerisque. Sed risus massa,
                    suscipit et posuere ut, vestibulum id eros. Morbi leo enim,
                    iaculis dapibus dictum vel, pellentesque a purus. Aliquam
                    vitae diam tellus. Integer nec urna vel justo fringilla
                    dictum.
                  </p>
                </div>

                {/* Comentario 2 */}
                <div className='comment-item'>
                  <div className='comment-header'>
                    <span className='comment-author'>Nombre</span>
                    <span className='comment-type'>Comentarios</span>
                    <span className='comment-date'>Hoy a las 16:55</span>
                  </div>
                  <p className='comment-text'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse eu elementum est, id fringilla metus. Quisque
                    gravida est quis urna iaculis bibendum. Maecenas gravida
                    velit et ligula malesuada scelerisque. Sed risus massa,
                    suscipit et posuere ut, vestibulum id eros. Morbi leo enim,
                    iaculis dapibus dictum vel, pellentesque a purus. Aliquam
                    vitae diam tellus. Integer nec urna vel justo fringilla
                    dictum.
                  </p>
                </div>

                {/* Comentario 3 */}
                <div className='comment-item'>
                  <div className='comment-header'>
                    <span className='comment-author'>Nombre</span>
                    <span className='comment-type'>Comentarios</span>
                    <span className='comment-date'>Hoy a las 16:55</span>
                  </div>
                  <p className='comment-text'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse eu elementum est, id fringilla metus. Quisque
                    gravida est quis urna iaculis bibendum. Maecenas gravida
                    velit et ligula malesuada scelerisque. Sed risus massa,
                    suscipit et posuere ut, vestibulum id eros. Morbi leo enim,
                    iaculis dapibus dictum vel, pellentesque a purus. Aliquam
                    vitae diam tellus. Integer nec urna vel justo fringilla
                    dictum.
                  </p>
                </div>

                {/* Input para nuevo comentario */}
                <div className='new-comment-section'>
                  <div className='comment-input-wrapper'>
                    <textarea
                      className='comment-input'
                      placeholder='Escribe un comentario...'
                      rows={4}
                    />
                    <button className='btn save create comment-submit-btn'>
                      Registrar nota
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewSeguimientoComercialContainer
